import { ref } from 'vue';

const VITE_DOMEINEN = import.meta.env.VITE_DOMEINEN.split(',');

const isZekerArbo = ref<boolean>(false);
const isZorgVanDeZaak = ref<boolean>(false);

const isZorgVanDeZaakUrl = (): boolean =>
  VITE_DOMEINEN.includes(window.location.hostname) &&
  window.location.hostname === VITE_DOMEINEN[0];

const isZekerArboUrl = (): boolean =>
  VITE_DOMEINEN.includes(window.location.hostname) &&
  window.location.hostname === VITE_DOMEINEN[1];

const setNetwerkbedrijfBooleans = (): void => {
  if (isZekerArboUrl()) {
    isZekerArbo.value = true;
  } else if (isZorgVanDeZaakUrl()) {
    isZorgVanDeZaak.value = true;
  }
};

export { isZorgVanDeZaak, isZekerArbo, setNetwerkbedrijfBooleans };
